import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Thumbnail from "../components/thumbnail"

const IndexPage = () => {
  return (
    <Layout>
      <SEO
        title="Home"
        description="Models based on Eadweard Muybridge motion studies create the illusion of a 3d miniature galloping horse."
        bodyClass="horseBackground"
      />
      <div className="thumbnail thumbnail1">
        <Thumbnail
          to="/interactive/grow"
          alt="Grow interactive horse"
          src="/thumbnail/interactive/grow.png"
        />
      </div>
      <div className="thumbnail thumbnail2">
        <Thumbnail
          to="/video/grow"
          alt="Grow video horse"
          src="/thumbnail/video/grow.png"
        />
      </div>
      <div className="thumbnail thumbnail3">
        <Thumbnail
          to="/interactive/3d"
          alt="Rotate interactive horse"
          src="/thumbnail/interactive/3d.png"
        />
      </div>
      <div className="thumbnail thumbnail4">
        <Thumbnail
          to="/video/doc"
          alt="Making of video"
          src="/thumbnail/video/doc.png"
        />
      </div>
    </Layout>
  )
}

export default IndexPage
